import axios from "axios";
import { ToastProgrammatic as Toast } from "buefy";
import router from "../router";

export default {
  initApp() {
    axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT;
    axios.interceptors.response.use(responseInterceptor, errorInterceptor);
  }
};

const errorInterceptor = error => {
  // check if it's a server error
  if (!error.response) {
    Toast.open({
      duration: 2500,
      message: "Network/Server Fehler.",
      position: "is-top",
      type: "is-danger"
    });
    return Promise.reject(error);
  }

  // all the other error responses
  switch (error.response.status) {
    case 400:
      Toast.open({
        duration: 2500,
        message: "Der Endpunkt konnte nicht gefunden werden.",
        position: "is-top",
        type: "is-warning"
      });
      break;

    case 401: // authentication error, logout the user
      Toast.open({
        duration: 2500,
        message: "Login ist abgelaufen. Bitten loggen Sie sich wieder ein.",
        position: "is-top",
        type: "is-warning"
      });
      localStorage.removeItem("access_token");
      router.push("/login");
      break;

    case 403:
      Toast.open({
        duration: 2500,
        message: "Sie sind leider nicht berechtigt diese Aktion durchzuführen.",
        position: "is-top",
        type: "is-warning"
      });
      localStorage.removeItem("access_token");
      router.push("/login");
      break;

    case 409:
      Toast.open({
        duration: 2500,
        message: "Es gibt einen Konflikt mit dieser Aktion.",
        position: "is-top",
        type: "is-warning"
      });
      break;

    case 413:
      Toast.open({
        duration: 2500,
        message: "Die Datei ist leider zu groß.",
        position: "is-top",
        type: "is-warning"
      });
      break;

    default:
      Toast.open({
        duration: 2500,
        message: "Server Fehler.",
        position: "is-top",
        type: "is-danger"
      });
  }
  return Promise.reject(error);
};

// Interceptor for responses
const responseInterceptor = response => {
  return response;
};
